import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Form, Input, Button, Card } from 'antd';

interface ChangePasswordFormValues {
  newPassword: string;
  confirmPassword: string;
}

const ChangePassword: React.FC = () => {
  const [form] = Form.useForm<ChangePasswordFormValues>();

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleFinish = (_values: ChangePasswordFormValues): void => {
    // TODO: Implement password change API call
  };

  return (
    <div className="profile-container">
      <Container>
        <Row>
          <Col>
            <h2 className="page-heading">Manage Password</h2>
            <Card>
              <Form form={form} className="profile-form" layout="vertical" onFinish={handleFinish}>
                <Row>
                  <Col sm={6}>
                    <Form.Item
                      label="New Password"
                      name="newPassword"
                      rules={[{ required: true, message: 'Please enter new password' }]}
                    >
                      <Input.Password placeholder="Enter New Password" />
                    </Form.Item>
                  </Col>
                  <Col sm={6}>
                    <Form.Item
                      label="Confirm Password"
                      name="confirmPassword"
                      rules={[
                        { required: true, message: 'Please confirm password' },
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            if (!value || getFieldValue('newPassword') === value) {
                              return Promise.resolve();
                            }
                            return Promise.reject(new Error('Passwords do not match'));
                          },
                        }),
                      ]}
                    >
                      <Input.Password placeholder="Confirm Password" />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Item className="gx-text-center">
                      <Button type="primary" htmlType="submit">
                        Update
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ChangePassword;
